export const jarvisOnestockActionCenterConstants = {
    GET_ONESTOCK_ACTION_CENTER_DATA_SAGA : "GET_ONESTOCK_ACTION_CENTER_DATA_SAGA",
    GET_ONESTOCK_ACTION_CENTER_DATA_APIS: "/onestock/action-centre/list",
    GET_ONESTOCK_ACTION_CENTER_DATA_REQUEST : "GET_ONESTOCK_ACTION_CENTER_DATA_REQUEST",
    GET_ONESTOCK_ACTION_CENTER_DATA_RESPONSE : "GET_ONESTOCK_ACTION_CENTER_DATA_RESPONSE",
}